export const GOOGLE_MAP_API_KEY = {
  development: 'AIzaSyBVeH-_GM9DUiugj1G-P2MLGU5cLSrS4WI',
  staging: 'AIzaSyBssavxD_YCltS8ZLWlobUwKUafRCEUafU',
  production: 'AIzaSyAX86y4r8h6wfk3Pe18LuRVyk5ChQbds5I',
};
